<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <card class="card" title="Make All Rack Barcodes">
          <div>
            <form @submit.prevent>
              <div class="row">
                <div class="col-md-4">
                  <fg-input type="text" label="System" v-model="populate.system">
                  </fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input type="text" label="Rack" v-model="populate.rack">
                  </fg-input>
                </div>
              </div>

              <div class="row"> </div>

              <div class="row"></div>

              <div class="row"></div>

              <div class="text-center">
                <p-button
                  type="info"
                  round
                  @click.native.prevent="populateBarcodes"
                >
                  Populate Barcodes
                </p-button>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </card>
      </div>
      <div class="col-md-6">
        <card class="card" title="Make Single Barcode">
          <div>
            <form @submit.prevent>
              <div class="row">
                <div class="col-md-4">
                  <fg-input type="text" label="System" v-model="singlePopulate.system">
                  </fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input type="text" label="Rack" v-model="singlePopulate.rack">
                  </fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input type="Number" label="Number" v-model="singlePopulate.number">
                  </fg-input>
                </div>
              </div>

              <div class="row"> </div>

              <div class="row"></div>

              <div class="row"></div>

              <div class="text-center">
                <p-button
                  type="info"
                  round
                  @click.native.prevent="populateSingleBarcode"
                >
                  Populate Barcode
                </p-button>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </card>
      </div>
    </div>
    <div id="singleCode" class="row" v-show="single">
      <div class="col-sm-6 col-md-6 col-lg-6">
        <svg id="singleBarcode"></svg>
      </div>
    </div>
    <br />
    <div id="multiCodes" class="row" v-show="multiple">
      <div class="col-sm-6 col-md-4 col-lg-4" v-for="index in 48" :key="index">
        <svg :id="'barcode' + index"></svg>
      </div>
    </div>
  </div>
    
</template>
<script>
//import * as shelveOrderService from "../../services/shelveOrder.service";
//import { EventBus } from "@/event-bus";
//import { createEmptySpaceArr } from "../../helpers/emptyRacks";

var JsBarcode = require('jsbarcode');

export default {
  data() {
    return {
      populate: {
        system: "",
        rack: "",
        notes: "",
      },
      singlePopulate: {
        system: "",
        rack: "",
        number: "",
        notes: "",
      },
      numbers: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      racks: null,
      shipReady: false,
      badMessage: "",
      warning: false,
      duplicate: false,
      ready: false,
      warningMessage: "ERROR! :::: ",
      duplicateMessage: "DUPLICATE! :::: This Item is a duplicate in the order.",
      readyMessage: "",
      multiple: true,
      single: true,
    };
  },
  methods: {
    close1: function() {
      this.warning = false;
      this.warningMessage = "Error! :::: ";
    },
    populateBarcodes: function() {
      this.multiple = true;
      this.single = false;
      console.log("Making Barcodes");
      let mySystem = this.populate.system;
      let myRack = this.populate.rack;
      console.log("System: ");
      console.log(mySystem);
      console.log("Rack: ");
      console.log(myRack);
      let arrCounter = 0;
      for (let i=0; i < 8; i++) {
        for (let j=0; j < 6; j++) {
          arrCounter += 1;
          let barcodeValue = `${mySystem}-${myRack}-`;
          let zeros;
          if (arrCounter.toString().length == 1) {
            zeros = "00000";
          } else {
            zeros = "0000"
          }
          barcodeValue = barcodeValue + zeros + arrCounter;
          let newBarcode = JsBarcode(`#barcode${arrCounter}`, barcodeValue);
        }
      }
      this.populate.system = "";
      this.populate.rack = "";
      const prtHtml = document.getElementById('multiCodes').innerHTML;
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      //WinPrint.close();
      return;
    },
    populateSingleBarcode: function() {
      this.single = true;
      this.multiple = false;
      let mySystem = this.singlePopulate.system;
      let myRack = this.singlePopulate.rack;
      let myNumber = this.singlePopulate.number;
      let barcodeValue = `${mySystem}-${myRack}-`;
      if (myNumber.toString().length == 1) {
        barcodeValue = barcodeValue + "00000" + myNumber;
      } else {
        barcodeValue = barcodeValue + "0000" + myNumber;
      }
      let newBarcode = JsBarcode(`#singleBarcode`, barcodeValue);

      this.singlePopulate.system = "";
      this.singlePopulate.rack = "";
      this.singlePopulate.number = "";
      const prtHtml = document.getElementById('singleCode').innerHTML;
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      //WinPrint.close();
      return;
    }
  },
}
</script>

